import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import { CovenantReviewGrid } from '$/components/covenant-review-grid';
import { getCreditSightsCovenantReviewFeatureFlagState } from '$/store/release-feature-flags/selectors';
import * as Bixby from '$/core';
import HeadingBlock from '$/components/global/heading';
import NotFound from '$/pages/not-found';
import { toastError } from '$/store/toast/actions';

interface ICovenantReviewProps {
  featureFlags?: string[];
  isCreditSightsCovenantReviewEnabled: boolean;
  dispatchToastError: (message: string) => void;
}

const CovenantReview: React.FC<ICovenantReviewProps> = props => {
  const { featureFlags: featureFlags = [], isCreditSightsCovenantReviewEnabled, dispatchToastError } = props;

  if (
    featureFlags.includes(Bixby.Constants.CLIENT_CREDITSIGHTS_COVENANT_REVIEW) &&
    isCreditSightsCovenantReviewEnabled
  ) {
    return (
      <React.Fragment>
        <section className="covenant-review-section">
          <HeadingBlock title="Covenant Review" />
          <CovenantReviewGrid dispatchToastError={dispatchToastError} />
        </section>
      </React.Fragment>
    );
  }

  return <NotFound />;
};

function mapDispatchToProps(dispatch: any) {
  return {
    dispatchToastError: (message: string) => dispatch(toastError(message)),
  };
}

function mapStateToProps(state: AppState) {
  const { isCreditSightsCovenantReviewEnabled } = getCreditSightsCovenantReviewFeatureFlagState(state);

  return {
    featureFlags: state.loginState.featureFlags,
    isCreditSightsCovenantReviewEnabled,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CovenantReview);
